<script setup lang="ts">
    import useConfigStore from '@/store/config.store';
    import useProductStore from '@/store/product.store';
    import { imageAndFabricWorldUpdater, canvasReduction } from '@/composables/useMaterialUpdater';
    import { storeToRefs } from 'pinia';
    import { computed, ref, useTemplateRef, onMounted } from 'vue';

    const { selectedProduct } = storeToRefs(useProductStore());
    const poleColor = computed(() => selectedProduct.value.configuration.poleColor);
    const { fonts, uniqueId } = storeToRefs(useConfigStore());

    const imgSrc = ref('');
    const imgContainer = useTemplateRef('img-container');

    const materialToImage = imageAndFabricWorldUpdater(poleColor, fonts, 1, false, uniqueId.value);

    function updateImage() {
        materialToImage(selectedProduct.value.configuration.fields).then((canvasObject) => {
            if (canvasObject === undefined) {
                return;
            }
            const height = (imgContainer.value?.getBoundingClientRect().height ?? 100) * 0.8;
            imgSrc.value = canvasReduction(canvasObject.canvas, undefined, height).toDataURL('image/png');
        });
    }

    defineEmits<{ hideImage: [] }>();

    onMounted(() => {
        updateImage();
    });
</script>
<template>
    <div
        id="img-container"
        ref="img-container"
        class="relative z-20 flex h-full w-full items-center justify-center bg-[#edf5fe]"
    >
        <div class="pointer-events-none absolute bottom-0 right-0 z-20 flex w-full flex-col items-end justify-end gap-2.5 p-4">
            <BaseButton
                class="transition-color pointer-events-auto absolute flex h-10 w-10 items-center justify-center border border-solid border-border-secondary bg-white font-bebas-neue text-xl font-medium text-primary shadow-none duration-300 hover:bg-hover-primary hover:text-white"
                @click="$emit('hideImage')"
            >
                <strong>3D</strong>
            </BaseButton>
        </div>
        <img
            id="bufferCanvas"
            class="object-contain"
            :src="imgSrc"
            alt="img"
        />
    </div>
</template>
